//region :: Imports ::
import MComponent from '../Component';
import {Fragment, ReactElement, ReactNode} from 'react';
import {Tooltip} from 'primereact/tooltip';
import {classNames} from 'primereact/utils';
import {InfoIcon} from '../../Icons';

//endregion

/** */
type Props = {
    targetName: string;
    tooltipContent: string | ReactNode;
}

/** */
class MHelpIcon extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        return (
            <Fragment>
                <Tooltip id={`${this.props.targetName}-tooltip`}
                         target={`.${this.props.targetName}`}
                         hideDelay={250}>
                    {
                        typeof this.props.tooltipContent === 'string'
                        ? <span>{this.props.tooltipContent}</span>
                        : this.props.tooltipContent}
                </Tooltip>
                <i className={classNames(`${this.props.targetName} ${InfoIcon.name} ${InfoIcon.color}`)}/>
            </Fragment>
        );

    }

}

export default MHelpIcon;
